export default {"cs":0.04,"de":0.99,"en":1,"es":0.86,"et":0.51,"fr":0.07,"nb-NO":0.04,"ru":0.14,"ta":0.95,"uk":0.33,"zh-Hant":0.3,"ja":0,"zh-Hans":0.01}